import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PluginComponent } from '../plugin.component';
import { Inspection } from '../../shared/models/index';
import { BasePlugin } from '../base-plugin.component';

@Component({
    templateUrl: './timesheet.component.html',
    standalone: false
})
export class TimeSheetPluginComponent extends BasePlugin implements OnInit {
  public plugin: any = {};
  inspectionId: string;
  public timeSheets: any;
  public inspection: Inspection;

  constructor(private route: ActivatedRoute, private cdRef: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {}

  config(
    plugin: any,
    inspection: Inspection,
    messages: Array<string>,
    showBreadcrumbs: boolean,
    showValidations: boolean,
    showContent: boolean
  ): void {
    super.config(plugin, inspection, messages, showBreadcrumbs, showValidations, showContent);
    this.timeSheets = this.plugin.config.TimeSheets;
    this.cdRef.detectChanges();
  }

  getEditRoute() {
    return [this.inspectionsRoute, this.inspection.id, 'plugins', this.plugin.id, 'timesheet', 'edit'];
  }
}

PluginComponent.plugins['timesheet'] = TimeSheetPluginComponent;
